import { render, staticRenderFns } from "./ProtectorUpsellModal.vue?vue&type=template&id=5e330bd1"
import script from "./ProtectorUpsellModal.vue?vue&type=script&lang=js"
export * from "./ProtectorUpsellModal.vue?vue&type=script&lang=js"
import style0 from "./ProtectorUpsellModal.vue?vue&type=style&index=0&id=5e330bd1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports